import { render, staticRenderFns } from "./ContratacaoDetalhesAdmin.vue?vue&type=template&id=57f52481"
import script from "./ContratacaoDetalhesAdmin.vue?vue&type=script&lang=js"
export * from "./ContratacaoDetalhesAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports